<div class="faq-container" *ngIf="!isClientNotEnrolled">
  <div class="faq-title">Perguntas frequentes</div>
  <div class="faq-list">
    <div class="faq-item" *ngFor="let faq of faqs; let i = index">
      <button class="faq-question" (click)="toggleFaq(i)" [attr.aria-expanded]="faq.open">
        <span class="faq-question-text">{{ faq.question }}</span>
        <img [src]="'images/ifood-landing/chevron.svg' | assetsUrl" alt="Abrir" class="faq-chevron" [class.open]="faq.open" />
      </button>
      <div class="faq-answer" *ngIf="faq.open">
        {{ faq.answer }}
      </div>
    </div>
  </div>
</div>

